import { userMetaDataKeys } from '@inbox-demo-nx/constants';
import SendBird from 'sendbird';

import { BadgeProps, StoreBadge, VerifiedBadge } from './Badge';

const UserBadge = ({
  user,
  ...props
}: { user: SendBird.User } & Omit<BadgeProps, 'source'>) => {
  const userType = (user?.metaData as Record<string, string>)[
    userMetaDataKeys.userType
  ];

  if (userType === 'official') {
    return <VerifiedBadge {...props} />;
  }
  if (userType === 'store') {
    return <StoreBadge {...props} />;
  }
  return null;
};

export default UserBadge;
